/**
 * Thank-you pages segmented by lead origin so Google Analytics, Google Ads
 * and Meta can attribute each conversion to the right funnel.
 */
export const THANK_YOU = {
  /** Formulário de agendamento de visita (qualquer página). */
  visita: "/obrigado-agendar-visita",
  /** Formulários nas páginas de imóveis. */
  imoveis: "/obrigado-imoveis",
  /** Formulários nas páginas de bairro. */
  bairros: "/obrigado-bairros",
  /** Formulários nas landing pages. */
  landing: "/obrigado-landing-page",
  /** Página de avaliação de imóvel. */
  avaliacao: "/obrigado-avaliacao",
  /** Página "Anuncie seu imóvel". */
  anuncie: "/obrigado-anuncie-seu-imovel",
  /** Fallback genérico (home, contato, blog). */
  geral: "/obrigado",
} as const;

export type ThankYouPath = (typeof THANK_YOU)[keyof typeof THANK_YOU];

export interface ThankYouCopy {
  title: string;
  subtitle: string;
  ctaLabel: string;
}

/** Copy shown on each thank-you page. */
export const THANK_YOU_COPY: Record<string, ThankYouCopy> = {
  [THANK_YOU.visita]: {
    title: "Visita solicitada com sucesso!",
    subtitle: "Recebemos seu pedido de visita e vamos confirmar o dia e o horário pelo WhatsApp.",
    ctaLabel: "Veja agora o imóvel",
  },
  [THANK_YOU.imoveis]: {
    title: "Obrigado pelo seu interesse!",
    subtitle: "Recebemos suas preferências e vamos enviar uma seleção de imóveis com o seu perfil.",
    ctaLabel: "Veja agora o imóvel",
  },
  [THANK_YOU.bairros]: {
    title: "Obrigado pelo seu contato!",
    subtitle: "Vamos preparar uma seleção de imóveis no bairro que você escolheu.",
    ctaLabel: "Ver imóveis do bairro",
  },
  [THANK_YOU.landing]: {
    title: "Obrigado pelo seu contato!",
    subtitle: "Recebemos suas preferências e entraremos em contato com as melhores opções.",
    ctaLabel: "Ver os apartamentos",
  },
  [THANK_YOU.avaliacao]: {
    title: "Avaliação solicitada!",
    subtitle: "Nossa equipe vai analisar os dados do seu imóvel e retornar com a avaliação de mercado.",
    ctaLabel: "Voltar à página",
  },
  [THANK_YOU.anuncie]: {
    title: "Cadastro do imóvel recebido!",
    subtitle: "Em breve entramos em contato para iniciar a divulgação do seu imóvel.",
    ctaLabel: "Voltar à página",
  },
  [THANK_YOU.geral]: {
    title: "Obrigado pelo seu contato!",
    subtitle: "Recebemos suas informações e nossa equipe entrará em contato em breve.",
    ctaLabel: "Veja agora o imóvel",
  },
};

export const thankYouCopy = (path: string): ThankYouCopy =>
  THANK_YOU_COPY[path] ?? THANK_YOU_COPY[THANK_YOU.geral];
